import { createSlice } from "@reduxjs/toolkit";
import {getSchoolIdpStatusRepo, postSchoolIdpRepo} from '../../repositories/school'

const schoolFormlSlice = createSlice({
  name: "schoolFormreducer",
  initialState: {
    schoolIdpLoading: null,
    schoolIdpSuccess: null,
    schoolIdpError: null,

    postSchoolIdpSuccess: null,
    postSchoolIdpError: null,  
  },

  reducers: {
    getSchoolIdpLoading(state, action) {
      return {
        ...state,
        schoolIdpLoading: true,
      };
    },
    getSchoolIdpSuccess(state, action) {
      return {
        ...state,
        schoolIdpLoading: false,
        schoolIdpSuccess: action.payload,
      };
    },
    getSchoolIdpFailure(state, action) {
      return {
        ...state,
        schoolIdpLoading: false,
        schoolIdpError: action.payload,
      };
    },

    clearSchoolIdpResponse(state, action) {
      return {
        ...state,
        schoolIdpSuccess: null,
      };
    },

    postSchoolIdpSuccess(state, action) {
      return {
        ...state,
        postSchoolIdpSuccess: action.payload,
      };
    },
    postSchoolIdpFailure(state, action) {
      return {
        ...state,
        postSchoolIdpError: action.payload,
      };
    },
  },
});

export const {
  getSchoolIdpLoading,
  getSchoolIdpSuccess,
  getSchoolIdpFailure,
  clearSchoolIdpResponse,
  postSchoolIdpSuccess,
  postSchoolIdpFailure,
} = schoolFormlSlice.actions;

export const getSchoolFormData = (params) => {
  return async (dispatch) => {
    await getSchoolIdpStatusRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getSchoolIdpSuccess(response?.data));
        } else {
          dispatch(getSchoolIdpFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getSchoolIdpFailure(error.message));
        }
      });
  };
};

export const postSchoolIdp = (data) => {
  return async (dispatch) => {
    await postSchoolIdpRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postSchoolIdpSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postSchoolIdpFailure(error.message));
        }
      });
  };
};

export default schoolFormlSlice.reducer;
